import React from 'react';
import ChartContent from './ChartContent';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './reducer';
import ChartTimeRange from './ChartTimeRange';
import Loading from './../../../common/loading/Loading';
import { customDataChart } from './../../../helpers/Chart';
import { getUnique } from './../../../helpers/Common';

const MIN_WIDTH = 700;
const CHART_HEIGHT = 230;

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyChart: getUnique(),
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      this.props.component !== nextProps.component ||
      this.props.data !== nextProps.data ||
      this.props.isLoading !== nextProps.isLoading
    ) {
      this.setState({ keyChart: getUnique() });
    }
  }

  getContent = data => {
    const { component, isLoading, timeRange } = this.props;
    const { keyChart } = this.state;
    const maxWidth = Math.max(component.width, MIN_WIDTH);
    const offsetWidth = 240;
    return (
      <div
        className="d-flex flex-fill flex-column position-relative"
        style={{
          width: maxWidth - offsetWidth,
        }}
      >
        {isLoading && <Loading />}
        <ChartTimeRange />
        <div className={isLoading ? 'bg-blur' : ''}>
          {data && data.length > 1 ? (
            <ChartContent
              key={keyChart}
              data={data}
              width={maxWidth - offsetWidth}
              height={CHART_HEIGHT}
              timeRange={timeRange}
            />
          ) : (
            <div style={{ height: CHART_HEIGHT }} />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { timeRange, data } = this.props;
    const customData = customDataChart(data, timeRange);

    return this.getContent(customData);
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state[REDUCER_NAME].isLoading,
    data: state[REDUCER_NAME].listChart,
    component: state[REDUCER_NAME].component,
    timeRange: state[REDUCER_NAME].timeRangeForChart,
  };
};

export default connect(mapStateToProps)(Chart);
